import React, { useState } from 'react';
import SchemaModal from '../../../ui/SchemaModal';
import Input from '../../../ui/Input';

const LABEL_COLORS = [
  { name: 'red', token: 'var(--label-red)' },
  { name: 'orange', token: 'var(--label-orange)' },
  { name: 'yellow', token: 'var(--label-yellow)' },
  { name: 'green', token: 'var(--label-green)' },
  { name: 'blue', token: 'var(--label-blue)' },
  { name: 'purple', token: 'var(--label-purple)' },
  { name: 'pink', token: 'var(--label-pink)' },
  { name: 'white', token: 'var(--label-white)' },
];

export default function NewLabelModal({ onConfirm, onClose }) {
  const [name, setName] = useState('');
  const [color, setColor] = useState('red');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim()) {
      onConfirm(name.trim(), color);
    }
  };

  return (
    <SchemaModal
      open
      onOpenChange={(next) => { if (!next) onClose(); }}
      size="sm"
      title="Neues Label"
      footer={
        <>
          <button type="button" className="btn-secondary" onClick={onClose}>Abbrechen</button>
          <button type="submit" form="new-label-form" className="btn-primary" disabled={!name.trim()}>Erstellen</button>
        </>
      }
    >
      <form id="new-label-form" onSubmit={handleSubmit}>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          maxLength={30}
          autoFocus
          aria-label="Label-Name"
          placeholder="Name…"
        />
        <div className="de-label-colors">
          {LABEL_COLORS.map((c) => (
            <button
              key={c.name}
              type="button"
              className={`de-label-colors__swatch${c.name === color ? ' de-label-colors__swatch--selected' : ''}`}
              style={{ background: c.token }}
              aria-label={`Farbe ${c.name}`}
              onClick={() => setColor(c.name)}
            />
          ))}
        </div>
      </form>
    </SchemaModal>
  );
}

export { LABEL_COLORS };
